export default __webpack_public_path__ + "static/media/edit.dd076324.svg";